<template>
    <div class="print-form" :style="printTemplate">
        <div :style="logo">
            <img :src="logoSrc" :style="logoImage">
        </div>
        <h1 :style="[printFormTitle, printFormMmainTitle]">
            {{  trans('general.page.space_forms.labels.billing') }}
        </h1>

        <!-- Child Info -->
        <div :style="printSection">
            <h3 :style="printFormTitle">
                {{  trans('general.page.space_forms.labels.child_info') }}
            </h3>

            <div :style="printItems">
                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.name') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.name }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.surname') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.surname }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.birthdate') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.birthday }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.gender') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.gender }}
                    </div>
                </div>
            </div>

            <div :style="printItems">
                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.social_share') }}
                    </div>
                    <div :style="printValue"
                         v-html="processedData.share_on_social_media ?
                         trans('general.page.space_forms.labels.yes') + ' ✔' : trans('general.page.space_forms.labels.no') + ' ×'"></div>
                </div>
            </div>

        </div>

        <!-- Parent Info -->
        <div :style="printSection" v-for="parent in processedData.parent">
            <h3 :style="printFormTitle">
                {{  trans('general.page.space_forms.labels.parent_info') }}
            </h3>

            <div :style="printItems">
                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.name') }}
                    </div>
                    <div :style="printValue">
                        {{ parent.name }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.surname') }}
                    </div>
                    <div :style="printValue">
                        {{ parent.surname }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.personal_id') }}
                    </div>
                    <div :style="printValue">
                        {{ parent.personal_id }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.email') }}
                    </div>
                    <div :style="printValue">
                        {{ parent.email }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.phone') }}
                    </div>
                    <div :style="printValue">
                        {{ parent.phone }}
                    </div>
                </div>
            </div>

        </div>

        <!-- Other Info -->
        <div :style="printSection">
            <h3 :style="printFormTitle">
                {{  trans('general.page.space_forms.labels.other_info') }}
            </h3>

            <div :style="printItems">
                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.vaccines') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.vaccines }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.allergies') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.allergies }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.other_info') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.other_info }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Emergency -->
        <div :style="printSection">
            <h3 :style="printFormTitle">
                {{  trans('general.page.space_forms.labels.emergency') }}
            </h3>

            <div :style="printItems">
                <div :style="printItem">
                    <div :style="printLabel">
                        {{  trans('general.page.space_forms.labels.emergency_number') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.emergency_number }}
                    </div>
                </div>

                <div :style="printItem">
                    <div :style="printLabel">

                        {{  trans('general.page.space_forms.labels.emergency_name') }}
                    </div>
                    <div :style="printValue">
                        {{ processedData.emergency_name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {unFlattenObjectKeys} from "../../../services/Defaults";

export default {
    name: "PrintFormTemplate",
    props: {
        formData: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            processedData: [],
            printTemplate: {
                fontFamily: '"Inter", Sans-serif',
            },
            logoSrc: '',
            logo: {
                display: 'flex',
                justifyContent: 'center',
            },
            logoImage: {
                maxWidth: '100%',
                maxHeight: '100px',
            },
            printSection: {
                margin: '20px 0',
            },
            printFormTitle: {
                textAlign: 'center',
                background: '#e5f0ed',
                padding: '5px',
                margin: '10px 0',
                borderRadius: '10px',
            },
            printFormMmainTitle: {
                background: '#EDECF5',
            },
            printItems: {
                borderRadius: '5px',
                display: 'flex',
                flexWrap: 'wrap',
                margin: '5px 0'
            },
            printItem: {
                background: '#F2F3F4',
                padding: '10px',
                borderRadius: '5px',
                height: '60px',
                flex: '1 0 calc(33.33% - 20px)',
                margin: '3px 5px',
                boxSizing: 'border-box',
            },
            printLabel: {
                fontSize: '12px',
                textTransform: 'uppercase',
            },
            printValue: {
                fontSize: '16px',
                fontWeight: 'bold',
            },
        };
    },
    methods: {
        printForm() {
            this.processFormData;

            setTimeout(() => {
                let modalBody = document.querySelector('.print-form');
                let win = window.open("", "_blank", 'fullscreen=1,channelmode=1,status=1,resizable=1');
                win.document.write('<html><head><title>Printing</title></head><body>');
                win.document.write(modalBody.innerHTML);
                win.document.write('</body></html>');
                win.document.title = 'Billing';
                win.document.close();

                setTimeout(() => {
                    win.print();
                }, 400);
            }, 600);
        },
    },
    computed: {
        processFormData() {
            return this.processedData = unFlattenObjectKeys(this.formData);
        }
    },
    mounted() {
        this.logoSrc = document.querySelector('.original-image').src;
    }
}


</script>

<style scoped>
.print-form {
    display: none; /* Hide the element by default */
}

@media print {
    .print-form {
        display: block; /* Show the element when printing */
    }
}
</style>
